import React from 'react'
import ContentMain from './ContentMain';
import Header from './Header';

const Content = () => {
  return (
    <div className="col-lg-10 col-md-12">
      <Header/>
      <ContentMain/>
    </div>
  )
}

export default Content